// ** Reducers Imports
import { combineReducers } from '@reduxjs/toolkit'
import navbar from './navbar'
import layout from './layout'
// import dashboardTodoSlice from 'src/views/dashboard/store/slice'
// import TodoListsSlice from 'src/views/dashboard/ecommerce/containers/todo/store/slice'
import authReducer from './auth/authSlice'
import pagesReducer from './pages/pagesSlice'
import previewReducer from '../store/slices/previewSlice'

const rootReducer = combineReducers({
  navbar,
  layout,
  // dashboardTodoSlice,
  // TodoListsSlice,
  auth: authReducer,
  pages: pagesReducer,
  preview: previewReducer
})

export default rootReducer
